import { CreateCheckoutSessionResponseData } from "@/domain/Subscription";
import api from "@/http/api";
import { Subscription } from "@/lib/redux/slices/userSlice/types";

class SubscriptionService {
  static readonly path = "subscriptions";

  async createCheckoutSession(body: {
    priceId: string;
    successUrl: string;
    cancelUrl: string;
  }) {
    return await api.post<CreateCheckoutSessionResponseData>(
      `${process.env.NEXT_PUBLIC_API}/${SubscriptionService.path}/checkout`,
      body
    );
  }

  async createPortalSession(body: { returnUrl: string }) {
    return await api.post<CreateCheckoutSessionResponseData>(
      `${process.env.NEXT_PUBLIC_API}/${SubscriptionService.path}/portal`,
      body
    );
  }

  async findMyActiveSubscription() {
    return await api.get<Subscription>(
      `${process.env.NEXT_PUBLIC_API}/${SubscriptionService.path}/me/active`
    );
  }
}

const instance = new SubscriptionService();
export default instance;
